module.exports = __webpack_public_path__ + "img/男-胃癌h.33ff8eb5.png";